{
  "common": {
    "px": "px",
    "px_uppercase": "PX",
    "seconds": "sekunder",
    "other": "-- Andet --",
    "customFieldExistsError": "Tilpasset-filt med dette navn findes allerede",
    "uniqueKeyNotUniqueError": "Denne Vigtig er ikke unik",
    "save": "Gem",
    "saving": "Gemmer",
    "typeAnOption": "Vælg en mulighed",
    "unsaved": "Ikke gemt",
    "noSubmissionsFound": "Der blev ikke fundet nogen indsendelser",
    "sortBy": "Sortér efter",
    "clearAll": "Ryd alt",
    "submitSurvey": "Indsend undersøgelsen",
    "select": "Vælg",
    "data"  : "data",
    "disqualifyAfterSubmitLower": "Diskvalificer efter indsendelse",
    "errorRetryAgain": "Fejl, prøv igen",
    "bubbleRadioStyleImageAlt": "Bobleradio-stil",
    "standardRadioStyleImageAlt": "Standard-radioknapstil",
    "recurringFrequency": {
      "once": "Én gang",
      "daily": "Dagligt",
      "weekly": "Ugentligt",
      "monthly": "Månedligt",
      "yearly": "Årligt"
    },
    "yes": "Ja",
    "no": "Nej",
    "updated": "Opdateret",
    "new": "Ny",
    "title": "Titel",
    "openSettings": "Åbn indstillingerne",
    "cloneField": "Klon felt",
    "removeField": "Fjern felt",
    "description": "Beskrivelse",
    "cannotAddThisField": "Du kan ikke tilføje dette felt",
    "overallOnly": "Kun samlet",
    "nextSlideDefault": "Næste slide (standard)",
    "nextQuestion": "Næste spørgsmål",
    "searchAddress": "Søg adresse",
    "recurringDonation": "Tilbagevendende donation",
    "recurringDonationDay": "Tilbagevendende donation 1 gang dagligt",
    "recurringDonationWeek": "Tilbagevendende donation 1 gang ugentligt",
    "recurringDonationMonth": "Gentagende donation 1 gang månedligt",
    "recurringDonationYear": "Gentagende donation 1 gang årligt",
    "integrate": "Integrer",
    "preview": "Forhåndsvisning",
    "back": "Tilbage",
    "alert": "Advarsel",
    "proceed": "Fortsæt",
    "confirm": "Bekræft",
    "cancel": "Annuller",
    "delete": "Slet",
    "embed": "Indlejr",
    "link": "Forbind",
    "linkModal": {
      "title": "Indsæt link",
      "urlLabel": "URL",
      "urlPlaceholder": "https://www.eksempel.dk",
      "invalidUrl": "URL er ugyldig"
    },
    "iframeEmbed": "Iframe-indlejring",
    "styles": "Stilarter",
    "options": "Valgmuligheder",
    "quickAdd": "Hurtig tilføjelse",
    "customFields": "Brugerdefinerede felter",
    "addObjectFields": "Tilføj objektfelter",
    "personalInfo": "Personlige oplysninger",
    "contactInfo": "Kontaktoplysninger",
    "submit": "Indsend",
    "address": "Adresse",
    "customized": "Tilpasset",
    "layout": "Layout",
    "showLabel": "Vis mærke",
    "showImage" : "Vis billede",
    "imageLayout" : "Billede Tilpasning af indhold",
    "imageLayoutSettings" : "Billede Tilpasning af indhold Konfig",
    "imageLayoutMode" : "Billede Tilpasning af indhold Tilstand",
    "surveyDefault" : "Undersøgelse Standard",
    "independent" : "Uafhængig",
    "image" : "Billede",
    "desktop" : "Pc",
    "mobile" : "Mobil",
    "desktopImage" : "Skrivebordsbillede",
    "mobileImage" : "Mobil Billede",
    "uploaded" : "Uploadet",
    "changeImage" : "Rediger billede",
    "uploadImage" : "Upload billede",
    "remove" : "Ryd",
    "background": "Baggrund",
    "buttonBackground": "Knap Baggrund",
    "fontColour": "Skriftfarve",
    "textFontColour": "Tekstfarve",
    "subTextFontColour": "Farve på undertekst",
    "selectThemes": "Vælge tema",
    "selectOne": "Vælg en",
    "enableIcon": "Aktivér ikon",
    "iconType": "Ikontype",
    "iconPlacement": "Ikonplacering",
    "filled": "Udfyldt",
    "textOnly": "Kun Indhold",
    "border": "Kant",
    "borderType": "Kanttype",
    "cornerRadius": "Hjørneradius",
    "width": "Bredde",
    "padding": "Polstring",
    "top": "Tinde",
    "bottom": "Bund",
    "left": "Venstre",
    "right": "Højre",
    "center": "Midte",
    "default": "Standard",
    "formDefault": "Standardformular",
    "shadow": "Skygge",
    "color": "Farve",
    "horizontal": "Vandret",
    "vertical": "Lodret",
    "blur": "Sløring",
    "spread": "Spredning",
    "fieldStyle": "Feltstil",
    "fontColor": "Skriftfarve",
    "inputTextFillColor": "Farve på tekstfyld til indtastning",
    "inputTextColor": "Farve på tekst",
    "primaryColor": "Primær farve",
    "primaryColorTooltip": "Kontrollerer Farve for svævetilstand og Dynamisk Land.",
    "inputTextColorTooltip": "Styrer Farve af Tekst skrevet i feedback Felter.",
    "mapPrimaryColorToButtonColor": "Kortlæg PRIMÆR Farve til Knap Farve",
    "label": "Mærke",
    "fontFamily": "Skriftfamilie",
    "size": "Størrelse",
    "weight": "Tykkelse",
    "fontWeightTooltip": "Gældende i tilfælde af afsnit",
    "fontWeightOptions": {
      "thin": "100 - Tynd",
      "extraLight": "200 - Extra Light",
      "light": "300 - Light",
      "normal": "400 - Normal",
      "medium": "500 - Medium",
      "semiBold": "600 - Halvfed",
      "bold": "700 - Fed"
    },
    "placeholder" : "Pladsholder",
    "customCSS" : "Brugerdefineret CSS",
    "backgroundImage" : "Baggrundsbillede",
    "headerImage" : "Overskriftsbillede",
    "miscellaneous" : "Diverse",
    "agencyBranding" : "Virksomhedens branding",
    "imageUploadMessage" : "Klik eller træk en billedfil til dette område for at uploade",
    "backgroundImageTooltipMessage" : "Baggrundsbilledet er beregnet til at dække hele siden og give en visuelt tiltalende baggrund for formularen. Klik på Forhåndsvisning for at se baggrundsbilledet.",
    "headerImageTooltipMessage" : "Overskriftsbilledet er designet til at dække hele formularens bredde og forbliver placeret øverst i formularen. Klik på Forhåndsvisning for at se headerbilledet.",
    "onSubmit" : "Ved indsendelse",
    "facebookPixelID" : "Facebook Pixel-id",
    "facebookPixelIDMessage" : "Ignorer dette felt, hvis du planlægger at bruge denne formular/undersøgelse inde i en tragt",
    "facebookPixelEvents" : "Facebook Pixel-events",
    "onpageView" : "Ved sidevisning",
    "stickyContact" : "Fastgjort kontakt",
    "stickyContactMessage" : "Husker og udfylder automatisk kontaktoplysninger, når brugeren vender tilbage på den samme enhed og browser.",
    "fieldDescription" : "Beskrivelse af feltet",
    "fieldTitle" : "Titel på felt",
    "queryKey" : "Forespørgselsnøgle",
    "querykeyTooltipMessage" : "Forespørgselsnøglen, der kan bruges som URL-parameter til at udfylde dette felt",
    "required" : "Påkrævet",
    "hidden" : "Skjult",
    "hiddenValue" : "Skjult værdi",
    "enableCountryPicker" : "Aktivér landevælger",
    "altText" : "Alt-tekst",
    "optionImageAlt" : "Option image",
    "bannerAlt" : "banner",
    "avatarAlt" : "Avatar Name",
    "alignment" : "Justering",
    "imageWidth" : "Billedets bredde",
    "imageHeight" : "Billedets højde",
    "logic" : "Logik",
    "pleaseInput" : "Indtast",
    "editHTML" : "Rediger HTML",
    "textStyle" : "Tekststil",
    "subText" : "Undertekst",
    "text" : "Tekst",
    "buttonStyle" : "Knapstil",
    "fullWidth" : "Fuld bredde",
    "htmlMessage" : "Den tilpassede HTML skal stå her",
    "htmlEditorHeader" : "TILPASSET JAVASCRIPT/HTML",
    "htmlEditorBodyMessage" : "Tilføj din kode her",
    "scriptAdded" : "Script Added!",
    "sourceAdded" : "Source Added!",
    "yesSave" : "Ja, gem",
    "cancelKeep" : "Annuller, behold",
    "done" : "Færdig",
    "addElement" : "Tilføj element",
    "addUrlLike" : "Inkluder gyldige URL'er såsom",
    "doNotAddRelativePath" : "Tilføj ikke relative stier som",
    "or" : "eller",
    "addCustomFields" : "Tilføj tilpassede felter",
    "customFieldSearch" : "Søg efter navn",
    "enterSourceValue" : "Indtast kildeværdi",
    "shortLabel" : "Kort beskrivelse",
    "shortLabelPlaceholder" : "Skrifttype a Kort beskrivelse",
    "labelPlaceholder" : "Skrive en etiket",
    "fileUploadPlaceholder" : "Upload en Fil",
    "imagePlaceholder" : "Image",
    "fillValuesPlaceholder" : "Udfyld værdier",
    "customCSSTooltip" : "Tilpasset CSS har forrang frem for formularstyling og temaer og kan have indflydelse på temaets styling.",
    "fontFamilyTooltip" : "Builder understøtter alle typer skrifttyper. Hvis du ikke kan se den på listen, kan du søge i rullelisten",
    "useGDPRCompliantFont" : "Brug en GDPR-kompatibel skrifttype",
    "enableTimezone" : "Aktivér tidszone",
    "inputStyle" : "Indtastningsstil",
    "conditionalLogicAlertOnSubmit" : "Betinget logik har forrang over meddelelsen/omdirigeringen her",
    "conditionalLogicAlertOnShowHide" : "Betinget logik har forrang over de skjulte indstillinger her",
    "placeholderFacebookPixelIdInput" : "Indtast Facebook Pixel-id",
    "doNotShowMessage" : "Vis ikke igen",
    "creatingForm" : "Oprettet din formular ...",
    "creatingSurvey" : "Oprettet din Undersøgelse ...",
    "creatingQuiz" : "Oprettet din quiz ...",
    "errorCreatingForm" : "Der opstod en fejl Oprettet din formular. Prøv igen.",
    "errorCreatingSurvey" : "Der opstod en fejl Oprettet din Undersøgelse. Prøv igen.",
    "errorCreatingQuiz" : "Der opstod en fejl Oprettet din quiz. Prøv igen.",
    "redirectMessage" : "Du vil blive omdirigeret til:",
    "themes" : {
      "themes" : "Temaer",
      "alertThemeMessage" : "Hvis du skifter tema, vil du miste alle de nuværende stilændringer.",
      "useTheme" : "Brug tema",
      "removeTheme" : "Fjern tema"
    },
    "box" : "Felt",
    "line" : "Linje",
    "message" : "Besked",
    "openUrl" : "Omdiriger til URL",
    "borderTypeList" : {
      "dotted" : "Prikket",
      "dashed" : "Stiplet",
      "solid" : "Fast",
      "none" : "Ingen"
    },
    "button" : "Knap",
    "emailNotification" : "E-mailnotifikation",
    "emailNotificationSubheader" : "Modtag en e-mail, når nogen udfylder din formular",
    "subject" : "Emne",
    "emailTo" : "E-mail (til)",
    "senderName" : "Afsenderens navn",
    "senderNameWarning" : "Dit (underkontonavn) vil blive tilføjet, hvis det efterlades tomt",
    "emailError" : "Der kræves mindst én e-mailadresse",
    "emailTooltip" : "Den første e-mailadresse er angivet til feltet 'Til'. Eventuelle efterfølgende e-mailadresser vil blive inkluderet i 'Cc'-feltet.",
    "clear" : "Fjern",
    "filter" : "Filtrer",
    "noResults" : "Ingen resultater",
    "search" : "Søg",
    "showNotificationsSettings" : "Vis meddelelsesindstillinger",
    "emailServicePaid" : "Denne funktion er en betalt tjeneste og vil medføre gebyrer baseret på dit brug.",
    "integration" : "Integration",
    "validation" : {
      "fieldRequired" : "Filt er Påkrævet",
      "maxLengthExceeded" : "Maks. Længde overskredet ({max} Tegn)"
    },
    "securityValidation": {
      "title":"Security issues detected. The following are not allowed:",
      "cookieAccess": "Cookie access detected (document.cookie). This is not allowed for security reasons.",
      "storageAccess": "localStorage.getItem() - reading from localStorage is not allowed.",
      "evalUsage": "Use of eval() is not allowed as it can execute arbitrary code.",
      "dynamicFunction": "Dynamic function creation (new Function) is not allowed for security reasons.",
      "stringExecution": "Passing strings to setTimeout/setInterval is not allowed as it can execute arbitrary code. Use function references instead."
    },
    "products": {
      "subscriptionBadge": "Abonnement",
      "trialBadge": "{days} dages gratis prøveversion",
      "setupFee": "Engangsgebyr for opsætning",
      "quantity": "Mængde",
      "productImageAlt": "Produktbillede",
      "bumpIconAlt": "Ikon for tillægsprodukt"
    },
    "payment" : {
      "payments" : "Betalinger",
      "connected" : "Tilsluttet",
      "connect" : "Tilslut",
      "liveModeOn" : "Live-tilstand",
      "status" : "Status",
      "test" : "Test",
      "live" : "Live",
      "paymentFields" : "Betalingsfelter",
      "suggestAnAmount" : "Foreslå et beløb",
      "recurringPayments" : "Tilbagevendende betalinger",
      "selectCurrency" : "Vælg valuta",
      "tagActiveBGColor" : "Farve på aktivt tag",
      "includeOtherAmount" : "Inkluder andet beløb",
      "footerInfo" : "Info om sidefod",
      "paymentType" : "Betalingstype",
      "sellProducts" : "Sælg produkter",
      "customAmount" : "Brugerdefineret beløb",
      "collectPayment" : "Opkræv betaling",
      "generalSettings" : "Generelle felter",
      "securePayments" : "*100 % Låse og sikre betalinger*",
      "error" : {
        "addMainProductFirst" : "Tilføj først et PRIMÆR produkt",
        "priceNotFoundForBumpProduct" : "Pris blev ikke fundet for Tillægsprodukt",
        "productAlreadyAdded" : "Produkt er allerede tilføjet"
      },
      "product" : {
        "addProduct" : "Tilføj produkt",
        "productSettings" : "Produktindstillinger",
        "bumpTag" : "Tillægsprodukt",
        "settingsAria" : "Produktindstillinger",
        "deleteAria" : "Slet produkt",
        "selectProduct" : "Vælg produkt",
        "editThisProduct" : "Sådan redigerer du dette produkt",
        "clickHere" : "Klik her",
        "show" : "Vis",
        "description" : "Beskrivelse",
        "image" : "Billede",
        "layoutSettings" : "Layout-indstillinger",
        "singleColumn" : "Enkelt kolonne",
        "twoColumn" : "To kolonner",
        "threeColumn" : "Tre kolonner",
        "maxProductError" : "Maksimalt 20 produkter er tilladt i en formular",
        "productSelectPlaceholder" : "Vælg et produkt",
        "orderConfirmation" : "Ordrebekræftelse",
        "orderConfirmationWarning" : "Når betalingen er gennemført, vises en side med ordrebekræftelse",
        "quantity" : "Mængde",
        "createProduct" : "Sådan opretter du et produkt",
        "noProductsAdded" : "Ingen produkter tilføjet endnu",
        "productsWillShowHere" : "Når Du Inkludere produkter, vil de Vise op Højre hende",
        "chooseProductType" : "Vælg din produkt",
        "mainProduct" : "PRIMÆR Produkt"
      },
      "bumProduct" : {
        "price" : "Pris",
        "variant" : "Variant",
        "headline" : "Overskrift",
        "otoHeadline" : "OTO Overskrift",
        "otoText" : "OTO Indhold",
        "enableImage" : "Aktivere Billede",
        "imageMessage" : "Vi får fat i Standard Produkt Billede",
        "orUploadADifferentImage" : "Eller Upload et andet Billede",
        "bumpProducts" : "Bump-produkter",
        "bumpProduct" : "Tillægsprodukt",
        "enableBump" : "Aktivere Bump",
        "orderBumpStyle" : "Supplerende produkt/service Stil",
        "classic" : "Klassisk",
        "modern" : "Moderne",
        "icon" : "Ikon",
        "bumpTemplate" : "Vælge Skabelon",
        "highlightText" : "Fremhøje Indhold",
        "showPrice" : "Vise Pris",
        "bumpPriceColor" : "Pris",
        "bumpIconColor" : "Bump Ikon",
        "bumpBackgroundColor" : "Bump Baggrund",
        "highlightTextColor" : "Fremhøje Indhold",
        "headlineColor" : "Overskrift",
        "otoHeadlineColor" : "OTO Overskrift",
        "otoTextColor" : "OTO Indhold",
        "bumpBorderColor" : "Bump Kant",
        "priceRequired" : "Pris er Påkrævet",
        "headlineRequired" : "Overskrift er Påkrævet",
        "otoHeadlineRequired" : "OTO-overskrift er påkrævet",
        "otoTextRequired" : "OTO-tekst er påkrævet",
        "bumpProductTooltip" : "En Lille Udvidelse tilbudt under Betalingen til Multiplicer Sortere Værdi. Kunder kan inkludere det med et individuelt klik.",
        "templateOne" : "Skabelon 1",
        "templateTwo" : "Skabelon 2",
        "templateThree" : "Skabelon 3",
        "animationIcon" : {
          "none" : "Ingen",
          "arrow" : "Pil",
          "fire" : "Brand",
          "plus" : "Plus",
          "giftBox" : "Felt",
          "timer" : "Nedtælling",
          "cracker" : "Kiks",
          "snack" : "Snack",
          "partyBalloon" : "Festballon",
          "flash" : "Flash",
          "money" : "Valuta",
          "spaceShuttle" : "Mellemrum"
        }
      },
      "coupons" : {
        "coupons" : "Kuponer",
        "enableCoupon" : "Aktivér kupon",
        "couponAlignment" : "Justering af kuponer",
        "left" : "Venstre",
        "right" : "Højre",
        "fullWidth" : "Fuld bredde",
        "tooltipMessage" : "Indstil placeringen af kuponinput fra nedenstående typer"
      }
    },
    "addressSettings" : {
      "autoComplete" : "Udfyld automatisk adresse",
      "addressfields" : "Adressefelter",
      "placeholderSearch" : "Søg efter en adresse",
      "autoCompleteTooltip" : "Giver mulighed for at søge og automatisk udfylde adressen.",
      "streetAddress" : "Adresse",
      "autoCompleteAddressTitle" : "Auto Afslutte Adresse",
      "newBadge" : "ny",
      "defaultLabel" : "Adresse",
      "searchPlaceholder" : "Søge Adresse",
      "mandataorySearch" : {
        "title" : "Påkrævet at Vælge Adresse in Søge Bar",
        "primaryText" : "Automatisk udfyldning af kun for Adresse",
        "secondaryText" : "Når Aktiveret, Når en Bruger interagerer med Adressefilten, Så skal de Vælge en gyldig adresse til Fortsæt.",
        "secondaryText1" : "Når deaktiveret Så kan de Fortsæt uden at vælge en adresse in Søge-bjælken."
      }
    },
    "autoResponder" : "Autosvar",
    "autoResponderSubheader" : "Send automatisk en e-mail til den person, der sender formularen (e-mailen indeholder en kopi af de oplysninger, vedkommende har indtastet i formularen)",
    "replyToEmail" : "Svar til e-mail",
    "open" : "Åben",
    "won" : "Vundet",
    "lost" : "Tabt",
    "abandon" : "Forlad",
    "selectAPipeline" : "Vælg en proces",
    "stage" : "Trin",
    "status" : "Status",
    "opportunityValue" : "Værdi af mulighed",
    "createNewPipeline" : "Opret ny pipeline",
    "editOpportunitySettings" : "Rediger indstillinger for muligheder",
    "contact" : "Kontakt",
    "opportunity" : "Mulighed",
    "business" : "Virksomhed",
    "add" : "Tilføj",
    "more" : "Mere",
    "opportunityHeading" : "Hvor ønsker du, at din mulighed skal opdateres?",
    "date" : {
      "dateSettings" : "Datoindstillinger",
      "dateFormat" : "Datoformat",
      "dateSeparator" : "Datoseparator",
      "dateFormatTooltipMessage" : "Vælg et datoformat. D står for dag, M for måneder og Y for år",
      "dateSeparatorTooltipMessage" : "Vælg en separator, der adskiller dag, måned og år i det format, der er valgt under Datoformat.",
      "disablePicker" : "Deaktiver vælger"
    },
    "restoreVersion" : "Gendan version",
    "versionHistory" : "Versionshistorik",
    "errorMessage" : "Fejl, prøv igen",
    "version" : "Version:",
    "currentVersion" : "Aktuel version",
    "messageStyling" : "Styling af beskeder",
    "validateEmailHeader" : "Bekræft e-mail",
    "validateEmailDescription" : "Knappen bliver synlig, når brugeren har indtastet sin e-mailadresse. Denne funktion er designet til at hjælpe dig med at generere kundeemner af høj kvalitet.",
    "verifyEmail" : "Bekræft e-mail",
    "validatePhoneHeader" : "Valider telefonnummer",
    "validatePhoneDescription" : "Knappen bliver synlig, når brugeren indtaster sit telefonnummer. Denne funktion er designet til at hjælpe dig med at generere kundeemner af høj kvalitet.",
    "verifyPhone" : "Verificer telefon",
    "validatePhoneWarning" : "For at aktivere SMS OTP-bekræftelse skal du sørge for, at dit telefonnummer er konfigureret i dine placeringsindstillinger",
    "addAnotherTnc" : "Tilføj yderligere vilkår og betingelser",
    "tnc1" : "Vilkår og betingelser 1",
    "tnc2" : "Vilkår og betingelser 2",
    "deleteCaps" : "SLET",
    "deleteConfirmation" : "Skriv SLET for at bekræfte",
    "marginPadding" : "Margin og udfyldning",
    "style" : {
      "formLayoutType" : "Formulartype",
      "layoutType" : "Layouttype",
      "surveyType" : "Undersøgelsestype",
      "oneColumn" : "En kolonne",
      "twoColumn" : "To kolonner",
      "singleLine" : "Enkelt linje",
      "fieldWidth" : "Feltbredde",
      "labelAlignment" : {
        "labelAlignment" : "Justering af etiket",
        "labelWidth" : "Etikettens bredde"
      },
      "fieldSpacing" : "Afstand mellem felter",
      "imageFieldSpacing" : "Billed- og feltafstand",
      "imageCornerRadius" : "Billedets hjørneradius",
      "color" : "farve",
      "fontColor" : "Skrifttypefarve",
      "inputBackgroundColor" : "Farve på baggrund til indtastning",
      "inputBorder" : "Kant",
      "layout" : "Layout",
      "colorsAndBackground" : "Farver og baggrund",
      "imageLayout" : {
        "imageLayout" : "Billede Tilpasning af indhold",
        "showImage" : "Vis billede",
        "image" : "Billede",
        "desktop" : {
          "topFixed" : "Øverst fast",
          "leftCenter" : "Venstre Midte",
          "rightCenter" : "Højre Midte",
          "leftFixed" : "Fast til venstre",
          "rightFixed" : "Fast til højre",
          "background" : "Baggrund"
        },
        "mobile" : {
          "header" : "Sidehoved",
          "background" : "Baggrund"
        }
      },
      "focusPoint" : {
        "title" : "Fokuspunkt",
        "reset" : "Nulstil",
        "noImage" : "Intet billede uploadet"
      },
      "advanceSettings" : "Avancerede Indstillinger",
      "inputField" : "Indtastningsfelt",
      "borderWidth" : "Kantbredde",
      "borderColor" : "Kantfarve",
      "borderStyle" : "Kantstil",
      "fontSize" : "Skriftstørrelse",
      "fontWeight" : "Skrifttykkelse",
      "labelColor" : "Etikettens farve",
      "placeholderColor" : "Farve på pladsholder",
      "shortLabelColor" : "Farve på kort beskrivelse"
    },
    "replyToTooltip" : "Tilpas standardmailadressen til svar ved at bruge {'{'}{'{'}contact.email{'}'}{'}'} for at aktivere svar til den kontakt, der indsender formularen.",
    "content" : "Indhold",
    "calculations" : "Beregninger",
    "uploadOptions" : "Indstillinger for upload",
    "opportunitySettingsWarning" : "Indstil indstillinger for muligheder ved at klikke på knappen Edit Opportunity Settings.",
    "startValue" : "Startværdi",
    "endValue" : "Slutværdi",
    "today" : "I dag",
    "thisWeek" : "Denne uge",
    "last7Days" : "Sidste 7 dage",
    "thisMonth" : "Denne måned",
    "last30Days" : "Sidste 30 dage",
    "question" : "Spørgsmål",
    "createContactOnPartialSubmission" : "Opret kontakt ved delvis indsendelse",
    "howItWorks" : "Hvordan fungerer det?",
    "createContactOnPartialSubmissionDescription" : "Afslut sliden, og klik på \"Next\". En ny kontakt bliver automatisk oprettet og gemt.",
    "swapWarningMessageSurvey" : "Redigering eller udskiftning af muligheder vil påvirke dette brugerdefinerede felt alle steder, hvor feltet bruges. Det kan også nulstille betinget logik. ",
    "swapWarningMessageForm" : "Redigering eller udskiftning af muligheder vil påvirke dette brugerdefinerede felt alle steder, hvor feltet bruges. ",
    "migrationWarningMessage" : "Denne funktionalitet er blevet migreret til undersøgelsens betingede logik.",
    "optionLabel" : "Valgmærke",
    "calculationValue" : "Beregning af værdi",
    "addOption" : "Tilføj mulighed",
    "enableCalculations" : "Aktivér beregninger",
    "allowOtherOption" : "Tillad anden valgmulighed",
    "productSelectionSubtext" : "Aktivere Individuel Eller udvalg af flere produkter",
    "multi" : "Flere",
    "single" : "Individuel",
    "productSelectionHeading" : "Produkt",
    "spreadToColumns" : "Spredning til kolonner",
    "columns" : "Kolonner",
    "customstyle" : "Stil",
    "standard" : "Standard",
    "bubble" : "Boble",
    "integratePopup" : {
      "title" : "Integrer formular",
      "embedCode" : "Indlejringskode",
      "useInFunnelOrEmbedCode" : "Brug i tragt/indlejringskode",
      "iframeEmbed" : "Indlejre i Iframe",
      "layout" : {
        "title" : "Integrer layouttype",
        "description" : "Vælg et layout, der skal integreres i en tragt eller et eksternt website",
        "allowMinimize" : "Tillad minimering",
        "minimizedTitlePlaceholder" : "Minimeret titel",
        "leftAlignAlt" : "Venstrejuster",
        "rightAlignAlt" : "Højrejuster"
      },
      "triggerType" : "Udløsertype",
      "triggers" : {
        "seconds" : "sekunder"
      },
      "activation" : {
        "title" : "Indstillinger for aktivering",
        "visit" : "besøg"
      },
      "deactivation" : {
        "title" : "Indstillinger for deaktivering",
        "times" : "gange"
      },
      "copyEmbedCode" : "Kopiér integreringskode",
      "copyFormLink" : "Kopiér link til formular",
      "openFormLink" : "Åbn link til formular",
      "invalidInput" : "Ugyldigt input!",
      "funnel" : {
        "funnel" : "Tragt",
        "chooseStep" : "Vælg en Trin",
        "copyCodeAndOpenFunnel" : "Kopiér Kode , og Åbne Tragt"
      },
      "share" : {
        "share" : "Del",
        "shareViaSocials" : "Dele Via Socials",
        "copyLink" : "Kopiér link"
      },
      "email" : {
        "email" : "E-mail",
        "shareViaEmail" : "Slet Via e-mail",
        "emailButton" : "E-mail",
        "blankTemplate" : "Tom Skabelon",
        "emailMarketingTemplates" : "Skabeloner til E-mail Markedsføring",
        "or" : "Eller",
        "chooseTemplate" : "Vælg mellem dine skabeloner",
        "continue" : "Fortsætte"
      }
    },
    "rating" : {
      "icon" : "Ikon",
      "iconAlignment" : "Justering af Ikon",
      "count" : "Optælling",
      "lowestRating" : "Min.. Bedømmelse",
      "highestRating" : "Maks. Bedømmelse",
      "iconSelectedState" : "Ikon Valgt Stat",
      "iconUnselectedState" : "Ikon fravalgt Stat",
      "rating" : "Bedømmelse",
      "ratingSettings" : "Indstillinger for bedømmelser",
      "calculationType" : {
        "calculationType" : "Sådan gemmes bedømmelsesfilt in Tilpasset Felter",
        "calculationTypeTooltip" : "Når Du Frekvens noget 4 Fra 5 stjerner, betyder det: - Absolut: 4 Fra 5 - Procentdel: 80 - Brøk: 0,8",
        "absolute" : "Absolut",
        "percentage" : "Procentdel",
        "fraction" : "Brøk"
      }
    },
    "desktopMode" : "Skrivebordstilstand",
    "mobileMode" : "Mobil tilstand",
    "versions" : "Varianter",
    "advanced" : "Avanceret",
    "edit" : "Rediger",
    "settings" : "Indstillinger",
    "submissions" : "Indsendelser",
    "undo" : "Fortryd",
    "redo" : "Lav om",
    "customValues" : "Brugerdefinerede værdier",
    "pickBgFromImage" : "Tilføjer en sløring til baggrunden af din beskedboks. Hvis du vælger en baggrundsfarve til beskedboksen, vises den over den slørede beskedboks.",
    "pickBgFromImageTip" : "Vælger en Farve med høj Sammenligne til BG-Billede. Besked: Anvendes ikke, hvis Formular Baggrund ikke har et Billede",
    "messageBackgroundBlur" : "Baggrundssløring",
    "confirmationMessage" : "Bekræftelsesbesked",
    "deleteOption" : "Mulighed for Slette",
    "deleteConfirmationModal" : {
      "defaultDescription" : "Sletter en mulighed vil påvirke denne Tilpasset-filt på tværs af hver Pladser, hvor filten bruges. Er du sikker på, at du ønsker at slette det?",
      "validationMessage" : "Indtast Slette to Gem.",
      "validationError" : "Indtast Slette"
    },
    "disqualifyImmediately" : "Diskvalificer øjeblikkeligt",
    "disqualifyAfterSubmit" : "Diskvalificer efter indsendelse",
    "generalSettings" : "Generelt Indstillinger",
    "advancedSettings" : "Avancerede Indstillinger",
    "customFieldName" : "Tilpasset Afdeling Navn",
    "customFieldNameTooltip" : "Denne Branche Navn er unik pr. Tilpasset Afdeling.",
    "uniqueKey" : "Unik nøgle",
    "uniqueKeyTooltip" : "Denne Vigtig er unik pr. Tilpasset Afdeling.",
    "selectContactAssociation" : "Klik på relationen til Kontakter",
    "associations" : "Tilknytninger",
    "createNewAssociation" : "Opret ny tilknytning",
    "selectAnAssociation" : "Vælg en tilknytning",
    "loadingAssociations" : "Indlæser associationer...",
    "unknownAssociation" : "Ukendt Relation",
    "manyToMany" : "Mange til mange",
    "failedToLoadAssociations" : "Det mislykkedes at indlæse associationer.",
    "noAssociationsFound" : "Ingen tilknytninger fundet",
    "keepThisField" : "Beholde denne Branche",
    "association" : "Partnerskab",
    "customObject" : "Brugerdefineret objekt",
    "customObjects" : "Brugerdefinerede objekter",
    "object" : "Objekt",
    "editAssociation" : "Rediger {objectName} -tilknytning",
    "editAssociationButton" : "{edit} {objectName} {association}",
    "fields" : "Felter",
    "primaryFieldWarning" : "{fieldName} er et PRIMÆR felt for {objectSingular} og er Påkrævet for at oprette eller Opdatere en {objectSingular}.",
    "primaryFieldTitle" : "{fieldName} er påkrævet for at oprette eller opdatere {objectSingular} dokument.",
    "removeAllFields" : "Fjern alle {objectSingular} felter",
    "customObjectsFallback" : "Brugerdefinerede objekter",
    "noneAssociation" : "Ingen",
    "noneAssociationDescription" : "Ingen Relation til Kontakter (ingen Kontakter Felter her)",
    "survey" : {
      "layoutType" : "Undersøgelsestype",
      "oneQuestionPerPage" : "Et spørgsmål ad gangen",
      "allQuestionsOnePage" : "Mange ad gangen"
    },
    "quizQuestions" : "Quiz Forespørgsel",
    "choiceElements" : "Valg af Komponenter",
    "otherElements" : "Andet Komponenter",
    "listEditor" : {
      "prefillValueHeader" : "Værdi af Forudfyld",
      "labelPlaceholder" : "Etiket",
      "valuePlaceholder" : "Værdi",
      "optionRequiredError" : "Valgmuligheden Filt er Påkrævet"
    },
    "field" : "Felt",
    "scoreEditor" : {
      "addFieldPlaceholder" : "Tilføj Felt",
      "fieldLabel" : "Felt",
      "numberLabel" : "nummer"
    },
    "fileUploadEditor" : {
      "fileTypes" : "Fil",
      "all" : "hver",
      "pdf" : "PDF",
      "docxDoc" : "DOCX/DOC",
      "png" : "PNG",
      "gif" : "GIF",
      "jpgJpeg" : "JPG/JPEG",
      "xlsCsv" : "XLS/CSV"
    },
    "ok": "Ok",
    "allowMultipleFiles": "Aktivere flere filer",
    "maxFileLimit": "Maks. Fil",
    "privacyPolicy": "Privatlivspolitik",
    "termsOfService": "Vilkår for service",
    "billingFrequency": "Faktureringsfrekvens",
    "otherAmount": "Andet beløb",
    "exampleUrlPlaceholder": "https://www.eksempel.dk",
    "checkboxStyles": {
      "standardAlt": "Standardstil for afkrydsningsfelt",
      "bubbleAlt": "Boblestil for afkrydsningsfelt"
    },
    "previewIcons" : {
      "exportAlt" : "Eksportikon",
      "shipmentAlt" : "Forsendelsesikon",
      "resultAlt" : "Ikon for resultatside"
    },
    "examples" : {
      "sampleUrl" : "https://eksempel.dk"
    },
    "showing": "Viser",
    "of": "af",
    "enterCouponCode": "Indtast kuponkode",
    "apply": "Anvend",
    "paymentWillBeProcessed": "Betalingen vil blive behandlet, så snart du går videre til næste trin",
    "paymentWillBeProcessedNextSlide": "Betalingen vil blive behandlet, så snart brugeren går videre til næste slide",
    "showThisAlertToUsers": "Vis denne advarsel til brugerne",
    "sixteenDigitCardNumber": "16-cifret kortnummer",
    "mmYy": "MM/ÅÅ",
    "cvc": "CVC",
    "pleaseFillRequiredFields": "Udfyld alle de påkrævede felter!",
    "opportunitySettingsIncomplete": "Indstillinger for muligheder er ufuldstændige",
    "opportunitySettingsIncompleteDescription": "Denne formular indeholder felter for muligheder, men indstillingerne for muligheder er ikke blevet opdateret. Konfigurer indstillingerne for muligheder for at fortsætte med at gemme formularen.",
    "ariaAttributes": {
      "iconSearch": "Ikonsøgning"
    },
    "alt": {
      "standardRadioStyle": "Standard-radioknapstil",
      "bubbleRadioStyle": "Bobleradio-stil"
    },
    "value": "Værdi",
    "jumpTo": "Gå til",
    "thankYouJohnDoe": "Tak, John Doe",
    "total": "I alt",
    "urlExamples": {
      "simple": "eksempel.dk",
      "https": "https://eksempel.dk",
      "withPath": "example.com/path",
      "fullPath": "https://www.example.com/path"
    }
  },
  "fields" : {
    "quizQuestions" : {
      "singleChoice" : "Individuelt valg",
      "multipleChoice" : "Flere valgmuligheder",
      "yesNo" : "Ja /Nej",
      "shortAnswer" : "Short Besvaret",
      "longAnswer" : "Langt Besvaret",
      "number" : "nummer",
      "singleDropdown" : "Individuel Rulleliste",
      "multiDropdown" : "Multi Rulleliste"
    },
    "personal" : {
      "fullName" : "Fulde navn",
      "firstName" : "Fornavn",
      "lastName" : "sidste Navn",
      "dateOfBirth" : "Fødselsdato",
      "phone" : "Telefon",
      "email" : "Gmail"
    },
    "submit" : {
      "button" : "Knap"
    },
    "integration" : {
      "sellProducts" : "Sælg produkter",
      "collectPayment" : "Opkræve Udbetaling"
    },
    "address" : {
      "address" : "Adresse",
      "streetAddress" : "Adresse",
      "city" : "By",
      "state" : "Stat",
      "country" : "Land",
      "postalCode" : "Kode",
      "organization" : "Organisation",
      "website" : "Hjemmeside",
      "websitePlaceholder" : "Web-URL skal stå her"
    },
    "text" : {
      "singleLine" : "Individuel Linje",
      "multiLine" : "Multi Linje",
      "textBoxList" : "Tekst Firkant Liste"
    },
    "choiceElements" : {
      "singleDropdown" : "Individuel Rulleliste",
      "multiDropdown" : "Multi Rulleliste",
      "checkbox" : "Afkrydsningsfelt",
      "radio" : "Radioknap"
    },
    "customized" : {
      "text" : "Klik for at redigere denne tekst",
      "html" : "Html",
      "htmlPlaceholder" : "Den Tilpasset HTML skal stå her",
      "captcha" : "Captcha",
      "source" : "Kilde",
      "termsAndConditions" : "T & C",
      "termsAndConditionsPlaceholder" : "Jeg accepterer vilkår og betingelser Udstedte Via virksomheden. Ved at opgive mit telefonnummer accepterer jeg Arve tekstbeskeder fra virksomheden.",
      "score" : "Score"
    },
    "other" : {
      "image" : "Billede",
      "fileUpload" : "Uploadfil",
      "monetary" : "Monetær",
      "number" : "nummer",
      "datePicker" : "Dato",
      "signature" : "Underskrift"
    },
    "customstyle" : "Stil",
    "standard" : "Standard",
    "bubble" : "Boble"
  },
  "survey": {
    "typeOfBuilder": "Undersøgelse",
    "survyeStyle": "Undersøgelsens stil",
    "surveyName": "Navn på undersøgelse",
    "surveyElement": "Undersøgelseselement",
    "addSurveyElement": "Tilføj undersøgelseselement",
    "cloneSlide": "Klon glide",
    "unsavedAlertMessage": "Undersøgelsen har arbejde, der ikke er gemt. Er du sikker på, at du vil forlade og kassere alt arbejde. der ikke er gemt?",
    "thirdPartyScriptAlertMessage": "Tredjepartsscripts inde i HTML-blokken kan give kraftig funktionalitet, men de medfører også risici for privatlivets fred, sikkerhed, ydeevne og sideadfærd. Derfor anbefaler vi, at du gennemgår indholdet af dette script, før du gemmer det i undersøgelsen.",
    "integrateHeader": "Integrer undersøgelse",
    "integrateSubHeader": "Brug følgende muligheder til at integrere din brugerdefinerede spørgeundersøgelse på dit website",
    "integrateCopyLinkMessage": "Kopiér linket nedenfor og del det nemt, hvor som helst du ønsker det.",
    "onSurveySubmission": "Ved indsendelse af undersøgelse",
    "surveySettings": "Indstillinger for undersøgelse",
    "oneQuestionAtTime": "Et spørgsmål ad gangen",
    "backButton": "Tilbage-knap",
    "backButtonTooltipMessage": "Tilbage-knappen vil hjælpe brugerne med at gå til den forrige slide",
    "disableAutoNavigation": "Deaktiver automatisk navigation",
    "disableAutoNavigationTooltipMessage": "Navigerer automatisk til Næste Glide Efter en Bruger svarer.",
    "autoNavigation": "Auto navigation",
    "autoNavigationTooltipMessage": "Navigerer automatisk til Næste Glide Efter en Bruger svarer.",
    "progressBar": "Statuslinje",
    "progressBarTooltipMessage": "Hvis du slår dette fra, fjernes statuslinjen fra undersøgelsen",
    "disableAnimation": "Deaktiver animation",
    "disableAnimationTooltipMessage": "Hvis du slår dette til, deaktiveres overgangsanimationenen for slides",
    "scrollToTop": "Rul til toppen",
    "scrollToTopTooltipMessage": "Hvis det er slået til, ruller undersøgelsen til toppen på næste slide",
    "submitSurvey": "Indsend undersøgelsen",
    "disqualifyImmediately": "Diskvalificer øjeblikkeligt",
    "disqualifyAfterSubmit": "Diskvalificer efter indsendelse",
    "disqualifyAfterSubmitLowerCase": "Diskvalificer efter indsend",
    "footerHTML": "HTML til sidefod",
    "footerHTMLMessage": "Du kan skrive brugerdefineret CSS (ved hjælp af style tag) og HTML inde i samme felt",
    "editFooter": "Rediger sidefod",
    "disqualifySettings": "Indstillinger for diskvalificering",
    "disqualifyImmediatelyLabel": "Straks",
    "disqualifyAfterSubmitLabel": "Efter indsendelse",
    "slideConflictAlertMessage": "Denne slide indeholder flere spørgsmål, der har en logik konfigureret. Dette kan medføre utilsigtet adfærd",
    "addSlide": "Tilføj slide",
    "settings": "Indstillinger",
    "delete": "Slet",
    "slideDeleteAlertMessage": "Er du sikker på, at du vil slette denne slide?",
    "slideDeleteBetweenAlertMessage": "Dette vil omarrangere de andre slides. Er du sikker på, at du vil slette denne dias?",
    "slideLabel": "Slide {n}",
    "slideName": "Slide-navn",
    "slidePosition": "Slide-position",
    "jumpTo": "Gå til",
    "jumpToSubText": "Gå til en specifik slide",
    "enableTimezoneSurvey": "Hvis du aktiverer denne mulighed, registreres oplysningerne om tidszonen for den person, der indsender undersøgelsen.",
    "footer": {
      "footer": "Sidefod",
      "enableNewFooter": "Aktivér ny sidefod",
      "stickToSurvey": " Sæt fast på undersøgelse",
      "backgroundFill": "Baggrundsudfyldning",
      "footerHeight": "Højde på sidefod",
      "enableProgressBar": "Aktivér statuslinje",
      "buttons": "Knapper",
      "button": "Knap",
      "buttonType": "Knaptype",
      "fillNext": "Udfyld (næste)",
      "fillPrevious": "Udfyld (forrige)",
      "fillSubmit": "Udfyld (indsend)",
      "textColor": "Knaptekst",
      "position": "Position",
      "previousText": "Forrige (tekst)",
      "nextText": "Næste (tekst)",
      "submitText": "Indsend (tekst)",
      "fillComplete": "Helt udfyldt",
      "fillInactive": "Udfyld inaktiv",
      "footerType": "Sidefodstype",
      "stickToCard": "Sæt fast på kortet",
      "stickToPage": "Sæt fast på siden",
      "stepTextColor": "Trin Indhold-farve",
      "progressBarFill": "Fylde af Statuslinje",
      "progressBarInactive": "Statuslinje Inaktiv",
      "arrowFill": "Pil Fylde",
      "submitColorMobile": "Indsend (Farve)",
      "arrowFillColor": "Pil Fylde Farve",
      "buttonTypes": {
        "textAndArrow": "Tekst og pil",
        "onlyText": "Kun tekst",
        "onlyArrow": "Kun pil"
      },
      "positions" : {
        "leftAndRight" : "Venstre og højre"
      },
      "placeholders" : {
        "prev" : "Forrige",
        "next" : "Næste",
        "submit" : "Indsend"
      }
    },
    "surveyNotfication" : "Meddelelse om undersøgelse",
    "style" : {
      "surveyPadding" : "Afstand til undersøgelse"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Integrer eller del undersøgelse",
      "share" : {
        "openFormLink" : "Åbne Link til Undersøgelse"
      },
      "email" : {
        "emailSubheader" : "Opret en tom E-mail og Indlejre din Undersøgelse, Eller Vælge a Skabelon og Indlejre it Straks."
      }
    },
    "autoResponderSubheader": "Send en automatiseret e-mail til den person, der indsender undersøgelsen (e-mailen indeholder en kopi af de oplysninger, de har indtastet i undersøgelsen).",
    "sendSubmissionsAsPdf": "Send undersøgelsesindsendelse som PDF",
    "switchToOneQuestionAtTimeOn": "Hvis du aktiverer 'One Spørgsmål at a Dato', forstyrres dit Aktuel betingede Logik",
    "switchToOneQuestionAtTimeOff": "Deaktiver 'One Spørgsmål at a Dato' påvirker din betingede Logik Konfig",
    "switchToOneQuestionAtTimeOnWarning": "Nogle betingelser vil ikke længere fungere som forventet, når spørgsmål er Fremmødte en at en Dato.",
    "switchToOneQuestionAtTimeOffWarning": " Nogle betingelser designet til individuelt-spørgsmål Flyde stopper med at fungere efter hensigten.",
    "createContactOnPartialSubmissionSubText": "Opretter en kontakt, når en bruger klikker på \"Næste\" på en hvilken som helst slide – selvom de ikke afslutter undersøgelsen.",
    "dragDrop": {
      "imageLabel": "Billede {n}",
      "htmlLabel": "HTML {n}",
      "defaultFolderName": "Undersøgelse {'|'} {name}",
      "defaultTermsHtml": "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Privatlivspolitik</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Servicevilkår</a></p>",
      "smsConsent": "Jeg giver samtykke til at modtage SMS-notifikationer, advarsler og lejlighedsvis markedsføringskommunikation fra virksomheden. Meddelelsesfrekvensen varierer. Besked- og datatakster kan gælde. Send en SMS med HELP til (XXX) XXX-XXXX for at få assistance. Du kan svare STOP for at afmelde dig når som helst."
    }
  },
  "form" : {
    "typeOfBuilder" : "Formular",
    "formStyle" : "Formularstil",
    "formElement" : "Formularelement",
    "addFormElement" : "Tilføj formularelement",
    "addConditionalLogic" : "Tilføj betinget logik",
    "openConditionalLogic" : "Åbn betinget logik",
    "inlineForm" : "Indbygget formular",
    "formName" : "Formularens navn",
    "fullScreenMode" : "Fuldskærmstilstand",
    "fullScreenModetooltip" : "Hvis du slår fuldskærmstilstand til, vil formularen udvide sig over hele beholderens bredde og strække sig ud til kanten af indlejringsområdet, mens den holder sig til formularens bredde.",
    "enableTimezoneForm" : "Aktivering af denne indstilling registrerer tidszoneoplysningerne for den person, der indsender formularen",
    "formSettings" : "Formularindstillinger",
    "unsavedAlertMessage" : "Undersøgelsen har arbejde, der ikke er gemt. Er du sikker på, at du vil forlade og kassere alt arbejde. der ikke er gemt?",
    "thirdPartyScriptAlertMessage" : "Tredjepartsscripts inde i HTML-blokken kan give kraftig funktionalitet, men de medfører også risici for privatlivets fred, sikkerhed, ydeevne og sideadfærd. Derfor anbefaler vi, at du gennemgår indholdet af dette script, før du gemmer det i formularen.",
    "onFormSubmission" : "Ved indsendelse af formular",
    "integrateForm" : "Integrer formular",
    "embedlayoutType" : "Indlejre Layout Skrive",
    "embedlayoutTypeSubMessage" : "Vælg et layout, der skal integreres i en tragt eller et eksternt website",
    "triggerType" : "Udløsertype",
    "showOnScrolling" : "Vis ved rulning",
    "showAfter" : "Vis efter",
    "seconds" : "sekunder",
    "alwaysShow" : "Vis altid",
    "activationOptions" : "Indstillinger for aktivering",
    "activateOn" : "Aktiver ved",
    "visit" : "besøg",
    "alwaysActivated" : "Altid aktiveret",
    "deactivationOptions" : "Indstillinger for deaktivering",
    "deactivateAfterShowing" : "Deaktiver efter visning",
    "times" : "gange",
    "deactiveOnceLeadCollected" : "Deaktiver, når kundeemnet er indsamlet",
    "neverDeactivate" : "Deaktiver aldrig",
    "copyEmbedCode" : "Kopiér indlejringskode",
    "copyFormLink" : "Kopiér link til formular",
    "openFormLink" : "Åbn link til formular",
    "inline" : "Indbygget",
    "inlineDescription" : "En indbygget formular vises sammen med indholdet af siden som et indbygget element. Det overlejrer ikke og kan ikke lukkes eller minimeres.",
    "inlineHoverDescription" : "En indbygget formular vises sammen med indholdet af siden som et indbygget element. Det overlejrer ikke og kan ikke lukkes eller minimeres.",
    "popup" : "Pop op",
    "popupDescription" : "En pop op viser formularen som en overlejring i en lysboks. Det kan ikke minimeres, men lukkes.",
    "popupHoverDescription" : "En pop op viser formularen som en overlejring i en lysboks. Det kan ikke minimeres, men lukkes.",
    "politeSlideIn" : "Midlertidig visning",
    "politeSlideInDescription" : "En midlertidig visning vises nederst på skærmen og forsvinder, når den lukkes",
    "politeSlideInHoverDescription" : "Vises på bunden af skærmen og forsvinder, når den er lukket",
    "stickySidebar" : "Fastgjort sidebjælke",
    "stickySidebarDescription" : "En fastgjort sidebjælke vises i siden af skærmen og kan minimeres til en fane, der sidder fast i siden af vinduet",
    "stickySidebarHoverDescription" : "Vises i siden af skærmen og kan minimeres til en fane, der sidder fast i siden af vinduet",
    "allowMinimize" : "Tillad minimering",
    "conditonalLogic" : {
      "conditions" : "Betingelser",
      "noExistingCondition" : "Ingen eksisterende betingelser endnu",
      "freeRoamMessage" : "Du kan frit bevæge dig rundt uden regler – i hvert fald indtil videre.",
      "addNewCondition" : "Tilføj ny tilstand",
      "redirectToUrl" : "Omdiriger til URL",
      "displayCustomMessage" : "Vis brugerdefineret meddelelse",
      "disqualifyLead" : "Diskvalificer kundeemne",
      "showHideFields" : "Vis/skjul felter",
      "jumpTo" : "Gå til",
      "redirectToUrlSubText" : "Omdiriger Bruger efter indsendelse",
      "displayCustomMessageSubText" : "Vise-beskeder baseret på Til Bruger-input",
      "disqualifyLeadSubText" : "Filter poster fra under specifikke betingelser",
      "showHideFieldsSubText" : "Ændre Følte Synlighed dynamisk",
      "openBelowUrl" : "Åbn nedenstående webadresse",
      "showCustomMessage" : "Vis brugerdefineret besked",
      "alertConditionDelete" : "Er du sikker på, at du vil slette denne betingelse?",
      "deleteCondition" : "Slet betingelse",
      "conditionExecutedMessage" : "Betingelserne vil blive udført i en top-down-rækkefølge.",
      "allOperationOptions" : {
        "isEqualTo" : "Er lig med",
        "isNotEqualTo" : "Er ikke lig med",
        "contains" : "Indeholder",
        "doesNotContain" : "Indeholder ikke",
        "startsWith" : "Starter med",
        "endsWith" : "Slutter med",
        "isEmpty" : "Er tom",
        "isFilled" : "Er fyldt",
        "before" : "Før",
        "after" : "Efter",
        "greaterThan" : "Større end",
        "lessThan" : "Mindre end",
        "between" : "Mellem",
        "isChecked" : "Er markeret",
        "isNotChecked" : "Er ikke tjekket"
      },
      "logic" : {
        "if" : "Hvis",
        "then" : "Så",
        "and" : "Og",
        "or" : "Eller"
      },
      "phoneAlertMessage" : "Hvis du vil søge efter telefonnumre med en landekode, skal du udtrykkeligt inkludere symbolet '+' i din søgeforespørgsel.",
      "deleteAlertMessage" : "Er du sikker på, at du vil slette dette felt? Den betingelse, der er knyttet til dette felt, vil også blive fjernet.",
      "deleteField" : "Slet felt",
      "jumpToDescription" : "Spring til en bestemt slide, når betingelserne er opfyldt",
      "cycleError" : "Kan ikke gemmes. Loop opdaget mellem {a} og {b}",
      "jumpToSlide" : "Gå til slide",
      "submitSurvey" : "Indsend undersøgelse",
      "pageTitle" : "P{index} - {title}",
      "selectSlideToJumpTo" : "klik Glide at springe Fra",
      "selectedSlide" : "Valgt slide",
      "typeValueHere" : "Indtast en værdi her",
      "field" : "Felt",
      "slide" : "Glide",
      "selectFieldOrSlide" : "Klik Branche Eller Glide",
      "selectFieldState" : "Klik Branche Land",
      "selectField" : "Vælge felt",
      "selectOption" : "Vælg mulighed",
      "jumpToTarget" : "Gå til",
      "jumpToQuestion" : "Gå til spørgsmål",
      "chooseQuestion" : "Vælg spørgsmål",
      "includeStart" : "Inkluder start",
      "includeEnd" : "Inkludere Slutning",
      "includeValue" : "Inkluder {value}",
      "hideField" : "Skjul felt",
      "hideFields" : "Skjul felter",
      "showField" : "Vis felt",
      "showFields" : "Vis felter",
      "additionalRulesPrefix" : "... og",
      "additionalRulesSuffix" : "andre {ifLabel} regler ...",
      "shownTargetsWithMore" : "{shown}, +{count} flere",
      "noConditionsAlt" : "Ingen betingelser endnu",
      "outcomeLabels" : {
        "show" : "Vis",
        "jumpTo" : "Gå til"
      }
    },
    "minimizedTitlePlaceholder": "Minimeret titel",
    "dragYourElementFromLeft": "Træk dine elementer hertil fra venstre",
    "formNotification": "Formularnotifikation",
    "sendSubmissionsAsPdf": "Send formularindsendelse som PDF",
    "style": {
      "formPadding": "Afstand til formular"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Integrer eller del formular",
      "share" : {
        "openFormLink" : "Åbne Link til Formular"
      },
      "email" : {
        "emailSubheader" : "Opret en tom e-mail og Indlejre din Formular, Eller Vælge a Skabelon og Indlejre it Straks."
      }
    },
    "choosePosition": "Vælg Status",
    "testBuild": "Test-build"
  },
  "quiz" : {
    "quizElement" : "Quizelement",
    "quizNotification" : "Quiznotifikation",
    "viewAndCustomise" : "Se og tilpas",
    "categoryAndScore" : "Kategori og score",
    "provideFeedback" : "Giv feedback",
    "addQuizElement" : "Tilføj quizelement",
    "typeOfBuilder" : "Quiz",
    "addQuestions" : "Tilføj spørgsmål",
    "dragAndDropQuestion" : "Træk og slip et Spørgsmål her.",
    "addNewPage" : "Tilføj ny Side",
    "editTemplate" : "Rediger Skabelon",
    "editResultPage" : "Rediger resultatside",
    "clonePage" : "Klon side",
    "category" : {
      "category" : "Kategori",
      "watchVideo" : "Se denne Video for at få mere at vide om, hvordan kategorier påvirker resultatsiden!",
      "useCategoryWhen" : "Brug Kategorier Når",
      "manageCategories" : "Administrer Kategorier",
      "howItWorks" : "Hvordan fungerer dette 🤔",
      "howItWorks2" : "Hvordan fungerer dette",
      "addCategoryMessage" : "Tilføj en ny kategori",
      "assignCategoryMessage" : "Tildel en kategori til hver mulighed",
      "editResultsMessage" : "Vise Kategori-score in Resultat Side",
      "addCategory" : "Tilføj Kategori",
      "deleteCategoryAlertMessage" : "Sletning af en Kategori vil resultere i hvile af den Kategori in hver Valgmulighederne",
      "editOrAddNewCategories" : "Du kan Rediger Eller Inkludere ny Kategorier",
      "toEvaluateTheResponder" : "For at sammenligne responderen baseret på flere faktorer",
      "showMultipleCategoryScore" : "Vise flere kategorier-score in Resultat Side",
      "displayVaryingContent" : "Visning varierende Indhold Til resultaterne Side afhængigt Til Kategori-scoreniveauet",
      "theOptionFieldIsRequired" : "Indstillingsfeltet er påkrævet",
      "addManage" : "Tilføj / Administrer",
      "enterCategoryPlaceholder" : "Indtast kategorinavn",
      "carouselAlt" : "Slide til forhåndsvisning af kategori"
    },
    "quizSettings" : "Indstillinger for quiz",
    "onQuizSubmission" : "Ved indsendelse af quiz",
    "settings" : "Indstillinger",
    "deletePage" : "Slet side",
    "quizResult" : {
      "resultTemplate" : "Resultat skabelon",
      "quizResultAlertMessage" : "Den valgte resultatside vil blive vist, når quizzen er afsluttet",
      "overallScoreLabel" : "Samlet score"
    },
    "autoResponderSubheader": "Send automatisk en e-mail til den person, der sender quizzen (e-mailen indeholder en kopi af de oplysninger, vedkommende har indtastet i quizzen)",
    "sendSubmissionsAsPdf": "Send quizindsendelse som PDF",
    "sendQuizResultsAsPdf": "Send quizresultatet som PDF",
    "integrateHeader": "Integrer quiz",
    "integrateSubHeader": "Brug følgende muligheder for at integrere din brugerdefinerede quiz på dit website",
    "integrateCopyLinkMessage": "Kopiér linket nedenfor og del det nemt, hvor som helst du ønsker det.",
    "pageLabel": "Side {n}",
    "pageName": "Sidenavn",
    "pagePosition": "Sideposition",
    "createContactOnPartialSubmissionSubText": "Opretter en kontakt, når en bruger klikker på \"Næste\" på en hvilken som helst slide – selvom de ikke fuldfører quizzen.",
    "integratePopup": {
      "shareOrEmbed": "Integrer eller del quiz",
      "share": {
        "openFormLink": "Åbne Link"
      },
      "email" : {
        "emailSubheader" : "Opret en tom e-mail og Indlejre din quiz, Eller Vælge a Skabelon og Indlejre it Straks."
      }
    }
  },
  "textEditor": {
    "textAlign": "Tekstjustering",
    "list": "Liste",
    "sourceCode": "Kildekode",
    "resetStyle": "Nulstil stil",
    "resetDocumentStyle": "Nulstil dokumentets stil"
  }
}
